import script from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NavigationDrawer.vue?vue&type=style&index=0&id=4ef9b3c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef9b3c4"]])

export default __exports__